import PropTypes from 'prop-types';

import RecordsTableHeader from './RecordsTableHeader';
import RecordsTableRow from './RecordsTableRow';

export function RecordsTable({ events }) {
  return (
    <div className="card-body p-1">
      <table className="table table-bordered table-auto">
        <RecordsTableHeader />
        <tbody>
          {events.map(({ ingestionTime, mensaje }, index) => (
            <RecordsTableRow
              ingestionTime={ingestionTime}
              mensaje={mensaje}
              index={index}
              key={index}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

RecordsTable.propTypes = {
  events: PropTypes.array.isRequired
};
export default RecordsTable;
